import { CheckCircle2, Layers } from "lucide-react";
import { BuyLink } from "@/components/BuyLink";

const GUIDE = [
  { k: "c1", name: "Metaland Wolfpack Exclusive", net: "Polygon", art: "/art/c1_exclusive.webp", perks: ["+15% Attack and the Wolfpack Fury skill", "3× credits on login, battle and quest rewards", "Gold Exclusive badge"] },
  { k: "c2", name: "Metaland Wolfpack 777", net: "Polygon", art: "/art/sample_c2.webp", perks: ["+20% Health & Defense and the Ironhide skill", "2.5× credits on login, battle and quest rewards", "Silver Wolfpack badge"] },
  { k: "c3", name: "Project PUPS", net: "Polygon", art: "/art/c3_pups.webp", perks: ["+25% XP & Loot", "1 free revive every day", "2× credits on login, battle and quest rewards"] },
  { k: "pack", name: "Pack Bonus", net: "All three Polygon", art: "/brand/mwp_coin.webp", perks: ["The top 3.5× credit multiplier", "The \"Pack Alpha\" title"] },
  { k: "sol", name: "Wolfpack Games 1/1 Wolves", net: "Solana", art: "/brand/mwp_coin.webp", perks: ["+5% to every stat per wolf held, up to +25%", "A free daily energy refill", "A second free daily lucky spin", "A place on the 1/1 Top Holders board"] },
  { k: "mwp", name: "$MWP Token", net: "Base", art: "/brand/mwp_coin.webp", perks: ["Credits +2% Bronze, +5% Silver, +10% Gold, +15% Platinum, on top of any NFT multiplier", "Tier badge on Profile, wolf page, Leaderboard and Showcase", "A place on the $MWP Holders board", "Platinum: a crown frame around your portrait everywhere"] },
];

export default function HoldingsGuide({ game: g0 }) {
  const game = g0 || {};
  const has = {
    c1: game.boosts?.c1, c2: game.boosts?.c2, c3: game.boosts?.c3, pack: game.boosts?.pack,
    sol: !!game.boosts?.sol, mwp: !!game.wallet?.mwp?.tier,
  };
  return (
    <section data-testid="holdings-guide" className="mt-14">
      <p className="text-[11px] uppercase tracking-[0.35em] font-mono-game text-amber-300/80 mb-2">The full list</p>
      <h2 className="font-display text-3xl text-white mb-2">What your holdings give you</h2>
      <p data-testid="holdings-guide-stacking" className="text-sm text-slate-400 mb-8 flex items-start gap-2 max-w-3xl">
        <Layers className="w-4 h-4 mt-0.5 shrink-0 text-cyan-300" />Only your best NFT credit multiplier counts, and $MWP's bonus multiplies on top of it. Stat boosts from different collections add together.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {GUIDE.map((g) => (
          <article key={g.k} data-testid={`guide-card-${g.k}`} className={`rounded-2xl border p-5 flex flex-col ${has[g.k] ? "border-emerald-400/40 bg-emerald-500/5" : "border-slate-800 bg-slate-950/60"}`}>
            <div className="flex items-center gap-4 mb-4">
              <img src={g.art} alt="" loading="lazy" className="w-14 h-14 rounded-xl object-cover" />
              <div className="min-w-0">
                <h3 className="font-display text-lg text-white leading-tight">{g.name}</h3>
                <p className="text-[11px] font-mono-game text-amber-200/80">{g.net}</p>
              </div>
            </div>
            <ul className="space-y-1.5 text-sm text-slate-300 mb-5">
              {g.perks.map((p) => <li key={p} className="flex gap-2"><span className="text-amber-300">·</span>{p}</li>)}
            </ul>
            <div className="mt-auto">
              {has[g.k] ? <span data-testid={`guide-have-${g.k}`} className="inline-flex items-center gap-1.5 text-sm text-emerald-300"><CheckCircle2 className="w-4 h-4" />You have this</span>
                : g.k === "pack" ? <span className="text-xs text-slate-500">Hold all three Polygon collections</span>
                : <BuyLink k={g.k} testid={`guide-buy-${g.k}`} />}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
